import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Button from '../Button';
const TransparentButton = /*#__PURE__*/React.forwardRef(({
  as: forwardedAs,
  ...props
}, forwardedRef) => /*#__PURE__*/React.createElement(Button, _extends({
  ref: forwardedRef,
  variant: 'transparent',
  forwardedAs: forwardedAs
}, props)));
export default TransparentButton;